// @flow

import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { isUserLoggedOn, refreshSessionToken } from '../network/samlService';
import configurationApi from '../network/api/configurationApi';
import { ENVIRONMENT } from '../const';
import { setApolloConfiguration } from '../state/page/pageService';
import type { ApolloConfiguration } from '../types/commonTypes';

type Props = {
  dispatch: () => void,
  component: any,
  authorization: string,
  isConnected: boolean,
  apolloConfiguration: ?ApolloConfiguration,
}

function initApp(dispatch: () => void) {
  configurationApi
    .fetchEnv()
    .then(response => response.json())
    .then((responseJson) => {
      Sentry.init({
        dsn: 'https://ab843b87ecc74a2d88d03dcfdabb1519@sentry.io/1470787',
        release: process.env.NODE_ENV === 'development' ? 'apollo@Localhost' : `apollo@${process.env.REACT_APP_GIT_SHA}`,
        environment: ENVIRONMENT[responseJson.env],
      });
      dispatch(setApolloConfiguration(responseJson));
    });
}

function PrivateRoute({ component: Component, dispatch, apolloConfiguration, ...rest }: Props) {
  if (!apolloConfiguration) {
    initApp(dispatch);
    return false;
  }
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isUserLoggedOn()) {
          return <Component {...props} />;
        }
        refreshSessionToken();
        return false;
      }}
    />
  );
}

export default withRouter(connect(state => ({
  apolloConfiguration: state.page.apolloConfiguration,
}))(PrivateRoute));
